import { Interval } from './interval';
import { Easing } from './easing';
//
// Smooth scrolling for anchors.
export function initializeAnchors() {
    const sidemenuDOM = document.querySelector('div.sidemenu');

    if (!sidemenuDOM) {
        return
    }

    const anchorElements = sidemenuDOM.querySelectorAll('div.side-item')

    var anchors = []

    for (let a = 0; a < anchorElements.length; a++) {
        var anchor = anchorElements[a]
        anchors.push(anchor)
    }

    for (let a = 0; a < anchors.length; a++) {
        var anchor = anchors[a]

        anchor.addEventListener('click', function (event) {
            event.preventDefault()

            // remove and add the active class
            anchors.forEach(element => {
                element.classList.remove('active')
            })
            event.srcElement.classList.add('active')

            const target = document.querySelectorAll('.sidemenu-anchor')
            if (target[a]) {
                // Find the Y position.
                let y = target[a].offsetTop
                scrollToY(y - 0)
            } else if (target[a] == null) {
                /* Scroll to top if somehow the
                target isn't found */

                scrollToY(0)
            }
        })
    }
}

// Sidemenu.
export function initializeSidemenu() {
    const sidemenuDOM = document.querySelector('div.sidemenu')

    if (!sidemenuDOM) {
        return
    }

    const sectionLinks = sidemenuDOM.querySelectorAll('.side-item')
    const sectionsElements = document.querySelectorAll('.sidemenu-anchor')
    
    var currentSection = 0
    var sections = []
    var offsetTops = []

    for (let a = 0; a < sectionsElements.length; a++) {
        sections.push(sectionsElements[a])
    }

    if (sections.length == 0 || sectionLinks.length == 0) {
        return
    }

    sectionLinks[0].classList.add('active'); // Find the nearest section.

    function onScroll(event) {
        let closestDistance = Infinity;
        let closestIndex = 0;
        const scrollY = window.scrollY || document.body.scrollTop || pageYOffset;

        for (const [index, offsetTop] of offsetTops.entries()) {
            const distance = Math.abs(offsetTop - scrollY);

            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        }

        if (currentSection != closestIndex) {
            sectionLinks[currentSection].classList.remove('active');
            sectionLinks[closestIndex].classList.add('active');
            currentSection = closestIndex;
        }
    }

    // Recalculate the offsetTops of the sections / anchors.
    function onResize() {
        offsetTops = sections.map(function (section) {
            return findOffsetTop(section)
        })
    }

    document.addEventListener('scroll', onScroll)

    function both() {
        onResize()
        onScroll()
    }

    addEventListener('resize', both)
    both()
}

function findOffsetTop(element) {
    let y = element.offsetTop
    while ((element = element.parentNode) && 'offsetTop' in element) {
        y += element.offsetTop
    }
    return y;
}

const scrollToY = function () {
    let intrvl = new Interval({ duration: 800 }, function (pos) {
        const ease = Easing.calc(pos, Easing.InOut, Easing.Expo);
        const position = Math.mix(this.begin, this.end, ease);
        scrollTo(0, position);
    })
    intrvl.stop();

    return function scrollToY(y) {
        intrvl.stop()
        intrvl.begin = window.scrollY || pageYOffset || document.body.offsetTop
        intrvl.end = y
        intrvl.start()
    }
}()

Math.mix = Math.mix || function mix(from, to, at) {
    return from + ((to - from) * at)
}

export function addDotsForTargets() {
    const sidemenu = document.querySelector('div.sidemenu')

    if (!sidemenu) {
        return
    }

    const targets = document.querySelectorAll('.sidemenu-anchor')

    var node = document.createElement("DIV")
    node.classList.add('side-item')

    for (let a = 0; a < targets.length; a++) {
        if (a === 0) {
            sidemenu.appendChild(node)
        } else { 
            const sideItem = document.querySelector('div.sidemenu div.side-item')
            sidemenu.appendChild(sideItem.cloneNode(false))
        }
    }
    sidemenu.firstElementChild.classList.add('active')
    return true
}